import React, { ReactNode } from 'react'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'

import s from './styles.module.scss'

import { cn } from '../../../shadcn/utils'

export interface ITestimonial {
  link: string
  text: ReactNode
  name: string
  jobTitle: ReactNode
  thumbnail: string
}

const TestimonialCard = ({
  testimonialData,
}: {
  testimonialData: ITestimonial
}) => {
  return (
    <article key={testimonialData.name} className={s.houseDetails}>
      <div className={s.youtubeLink}>
        <LiteYouTubeEmbed
          id={testimonialData.link}
          title='Titre'
          wrapperClass={s.youtubePlayer}
          iframeClass={s.iframeYoutubePlayer}
          playerClass={s.playerButton}
          activatedClass={s.activatedClass}
          containerElement='div'
          thumbnail={testimonialData.thumbnail}
        />
      </div>
      <div className={s.description}>
        <p className={cn(s.temoignage, 'line-clamp-[8]')}>
          {testimonialData.text}
        </p>
        <div className={s.descriptionFooter}>
          <p className={s.name}>{testimonialData.name}</p>
          <p className={cn(s.jobTitle, 'line-clamp-3')}>
            {testimonialData.jobTitle}
          </p>
        </div>
      </div>
    </article>
  )
}

export default TestimonialCard
